import { render, staticRenderFns } from "./CommunityBusinessNewsCard.vue?vue&type=template&id=928a9cfc&scoped=true&"
import script from "./CommunityBusinessNewsCard.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessNewsCard.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBusinessNewsCard.vue?vue&type=style&index=0&id=928a9cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928a9cfc",
  null
  
)

export default component.exports